var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let ProgressSelect = class ProgressSelect extends Vue {
    constructor() {
        super(...arguments);
        this.internalProgress = [];
    }
    mounted() {
        this.initialize();
    }
    initialize() {
        if (!this.progress.length) {
            return;
        }
        const internalProgress = this.progress.split('');
        this.internalProgress = internalProgress.map((rating) => Number(rating));
    }
    toggleRating(index) {
        if (!this.isEditing) {
            return;
        }
        this.internalProgress[index] = this.internalProgress[index] ? 0 : 1;
        this.$emit('progressUpdated', this.internalProgress.join(''));
    }
    progressChanged() {
        this.initialize();
    }
};
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], ProgressSelect.prototype, "progress", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], ProgressSelect.prototype, "isEditing", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], ProgressSelect.prototype, "status", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], ProgressSelect.prototype, "showTitle", void 0);
__decorate([
    Watch('progress'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ProgressSelect.prototype, "progressChanged", null);
ProgressSelect = __decorate([
    Component({})
], ProgressSelect);
export default ProgressSelect;
